import {Injectable} from '@angular/core';
import {AddOverlayComponent} from './add-overlay.component';

@Injectable()
export default class AddOverlayService {
  private component: AddOverlayComponent;

  public setComponent(comp: AddOverlayComponent) {
    this.component = comp;
  }

  public show() {
    this.component.show();
  }

  public hide() {
    this.component.visible = false;
  }

  public toggle() {
    this.component.visible = !this.component.visible;
    if(this.component.visible) {
      this.component.show();
    }
  }
}
